(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("node:module"));
	else if(typeof define === 'function' && define.amd)
		define(["node:module"], factory);
	else if(typeof exports === 'object')
		exports["shared"] = factory(require("node:module"));
	else
		root["shared"] = factory(root["node:module"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__906__) => {
return 